import {css} from 'styled-components'

export const clickable = css`
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.5;
  }
`
